export class AiSpendApi {
    client;
    constructor(client) {
        this.client = client;
    }
    /** The spend of a UTC month (`YYYY-MM`; the current one by default) - `ai_spend:view`. */
    spend(month) {
        return this.client.request({ method: 'GET', path: `/v1/ai/spend${month !== undefined ? `?month=${encodeURIComponent(month)}` : ''}`, auth: true });
    }
    /** The recorded exchange rates - `ai_spend:view`. */
    fxRates() {
        return this.client.request({ method: 'GET', path: '/v1/ai/fx-rates', auth: true });
    }
    /** Record an exchange rate (`rate` as decimal text, `1 from = rate to`) - `ai_spend:manage`; append-only, the actor is the session, the instant is the server's, and the rate is bounded (absolute range, 25 % from the one in force). */
    putFxRate(input) {
        return this.client.request({ method: 'POST', path: '/v1/ai/fx-rates', body: input, auth: true });
    }
}
export class VeloApi {
    client;
    constructor(client) {
        this.client = client;
    }
    /** What Vello can do, which intents the simulation lets be promoted, and the channels a kill switch may name (`sc_governance:view`). */
    intents() {
        return this.client.request({ method: 'GET', path: '/v1/velo/intents', auth: true });
    }
    /** The copilot of a conversation: Vello's state and handover package, the suggestions waiting (`conversation:read_body` at its market). */
    copilot(conversationId) {
        return this.client.request({ method: 'GET', path: `/v1/velo/conversations/${encodeURIComponent(conversationId)}/copilot`, auth: true });
    }
    /** An on-demand summary of the conversation (a metered model call; `conversation:manage`). */
    summarize(conversationId) {
        return this.client.request({ method: 'POST', path: `/v1/velo/conversations/${encodeURIComponent(conversationId)}/summary`, body: {}, auth: true });
    }
    /** The agent's word on a suggestion: sent as it was, sent after editing (with the interaction it was sent as), or discarded. */
    resolveSuggestion(turnId, action, interactionId) {
        return this.client.request({ method: 'POST', path: `/v1/velo/turns/${encodeURIComponent(turnId)}/resolution`, body: { action, ...(interactionId !== undefined ? { interactionId } : {}) }, auth: true });
    }
}
//# sourceMappingURL=velo.js.map